import { render, staticRenderFns } from "./ThePageSkeleton.vue?vue&type=template&id=469737e2&scoped=true&"
import script from "./ThePageSkeleton.vue?vue&type=script&lang=js&"
export * from "./ThePageSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ThePageSkeleton.vue?vue&type=style&index=0&id=469737e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469737e2",
  null
  
)

export default component.exports